import {
  ContainerForm,
  useContainerEnabledForm,
} from "../Properties/components/ContainerForm";
import { FormGroup } from "../Properties/components/FormGroup";
import { PriceCalloutsForm } from "./PriceCalloutsForm";

const containerDataTestId = "paywall-customization-price-callouts-container";

export const PriceCalloutProperties = () => (
  <ContainerForm
    containerDataTestId={containerDataTestId}
    containerClassName="pt-0"
    useHooks={useContainerEnabledForm}
  >
    <FormGroup
      data-testid="price-callouts-properties-form-group"
      className="space-y-0 divide-y-0"
      isEnabled
    >
      <PriceCalloutsForm />
    </FormGroup>
  </ContainerForm>
);
